import type { NavigateFunction } from "react-router-dom";
import { signOut } from "firebase/auth";
import { clearStoredEmailForSignIn } from "../api/auth";
import { clearSelectedPlanKey } from "./billingSelection";
import { useAuthStore } from "../store/authSlice";
import { useOnboardingStore } from "../store/onboardingSlice";
import { queryClient } from "../queryClient";
import { auth } from "../firebase";

export function resetPortalClientState() {
  clearStoredEmailForSignIn();
  clearSelectedPlanKey();
  useAuthStore.getState().reset();
  useOnboardingStore.getState().reset();
  queryClient.clear();
}

export async function logoutAndResetPortalSession(navigate: NavigateFunction) {
  await signOut(auth);
  resetPortalClientState();
  navigate("/login", { replace: true });
}
